import React from "react";
import Logs from "../../../../components/Logs";
import { VALAQUENTA_API_URL } from "../../../../api";

const VesselConfigLogsTab = (WrappedComponent) => {
  const Comp = (props) => {
    const actionsMapping = {
      add: {
        label: "Add",
        url: `${VALAQUENTA_API_URL}/vesselengine/api-config/`,
        method: "POST",
      },
      edit: {
        label: "Edit",
        url: `${VALAQUENTA_API_URL}/vesselengine/api-config/`,
        method: "PATCH",
      },
      delete: {
        label: "Delete",
        url: `${VALAQUENTA_API_URL}/vesselengine/api-config/`,
        method: "delete",
      },
      clone: {
        label: "Clone",
        url: `${VALAQUENTA_API_URL}/vesselengine/api-config/clone/`,
        method: "POST",
      },
    };

    return <WrappedComponent {...props} actionsMapping={actionsMapping} />;
  };
  return Comp;
};

export default VesselConfigLogsTab(Logs);
